export function manualByLangugue (languageCode: string) {
    let url;

    switch (languageCode) {
        case 'PT':
            url = 'https://ajuda.praticabr.com/hc/pt-br/articles/9033481977882--Manual-Completo-da-Plataforma-IOK';
            break;
        case 'ES':
            url = 'https://ajuda.praticabr.com/hc/es-bo/articles/9033481977882--Manual-Completo-de-la-Plataforma-IOK';
            break;
        case 'EN':
        case 'PL':
        case 'ZH':
        case 'RU':
        case 'DE':
        case 'FR':
        case 'EL':
            url = 'https://ajuda.praticabr.com/hc/en-us/articles/9033481977882--Complete-Manual-of-the-IOK-Platform';
            break;
        default:
            url = 'https://ajuda.praticabr.com/hc/en-us/articles/9033481977882--Complete-Manual-of-the-IOK-Platform';
    }

    return url;
};
